import type { RouteRecordRaw } from "vue-router";
// import Layout from "@/views/layouts/index.vue";
import FlowLayout from "@/views/layouts/flowLayout.vue";

const logisticsRouter: RouteRecordRaw[] = [
    {
        path: "/logistics",
        name: "Logistics",
        meta: { title: "物流中心" },
        component: FlowLayout,
        redirect: "/logistics/findLocation",
        children: [
            {
                path: "findLocation",
                name: "FindLocation",
                meta: { title: "查船" },
                component: () => import("@/views/pages/logistics/findLocation/index.vue")
            },
            {
                path: "truckLocation",
                name: "TruckLocation",
                meta: { title: "查车" },
                component: () => import("@/views/pages/logistics/truckLocation/index.vue")
            },
            {
                path: "shipInfoServiceFee",
                name: "ShipInfoServiceFee",
                meta: { title: "船务信息服务费" },
                component: () => import("@/views/pages/logistics/shipInfoServiceFee/index.vue")
            },
            {
                path: "shipInfoServiceFee/detail",
                name: "ShipInfoServiceFeeDetail",
                meta: { title: "船务信息服务费详情", hidden: true },
                component: () => import("@/views/pages/logistics/shipInfoServiceFee/detail/index.vue")
            },
            {
                path: "shipOrder",
                name: "ShipOrder",
                meta: { title: "运单" },
                component: () => import("@/views/pages/logistics/shipOrder/index.vue")
            },
            {
                path: "shipOrder/edit",
                name: "ShipOrderEdit",
                meta: { title: "新增找船", hidden: true },
                component: () => import("@/views/pages/logistics/shipOrder/edit/index.vue")
            },
            {
                path: "shipOrder/detail",
                name: "ShipOrderDetail",
                meta: { title: "运单详情", hidden: true },
                component: () => import("@/views/pages/logistics/shipOrder/detail/index.vue")
            }
        ]
    },
];

export default logisticsRouter;
